import DpEventBus from './dp-event-bus';
import VueEvents from './vue-events';
import VueDefinitions from './vue-definitions';
import VueNextRequest from './vue-next-request';
import documentReady from '@webapp-next/lib/document-ready';
import peopleGlobalRetroFeed from '@webapp-next/modules/people/global-retro-feed';
import { classicRouterRetrofeed } from '@webapp-next/router/classic';
import createI18n from '@webapp-next/lib/i18next/createI18n';
import PreferencesV2 from '@webapp-next/lib/request/webapp/user/preferences';
import checkFF from '@webapp-next/lib/feature-flag';
import {
  trackForInstall,
  trackForInstallLegacyModel,
  identifyAnalyticsUser,
} from '@/lib/tracking';
import SupportService from '@/lib/support';
import userHasPermission from '@/lib/user-has-permission';
import hasMultipleLocationSelected from '@/modules/schedule/composables/roster/has-multiple-location-selected';
import deputySdk from '../../../deputy-sdk';
import {
  getRootDeputyFrame,
  isWindowDeputyRootFrame,
} from '@webapp-next/global-libs/deputy-embed';
import checkIsLeaveManagementEnabled from '@apps-leave/composables/check-is-leave-management-enabled';
import saveTemplate from '@webapp-next/lib/request/webapp/schedule/template/save';
import employeesGet from '@webapp-next/lib/request/webapp/people/employees-get';
import classicBootstrapPromiseInitialize from '@/global-libs/classic-bootstrap-promise';
import { getCountryList } from '@webapp-next/apps/locations/src/requests/getCountryList';
import { getDapContext } from '@/lib/request/webapp/help-centre/get-dap-context';

// TODO: this will be the future place of this lib
// import initializeSegment from '@webapp-next/lib/segment';

// TODO: this will be the future place of this lib
// if (window.__APP__?.ANALYTICS?.segmentKey) {
//   window.__APP__.ANALYTICS.track = initializeSegment(window.__APP__.ANALYTICS);
// }

const isOnce = !window.$dt;

// allow boostrapPromise to work in iframe
if (window.DP) {
  if (!getRootDeputyFrame().DP?.BootstrapPromise) {
    classicBootstrapPromiseInitialize();
  }

  window.DP.BootstrapPromise = getRootDeputyFrame().DP?.BootstrapPromise;
}

window.DpEventBus = DpEventBus;

// detect iframe
if (!isWindowDeputyRootFrame()) {
  window.VueEventBus = getRootDeputyFrame().VueEventBus?.iframeInstance(
    window.name
  );
} else {
  window.VueEventBus = window.VueEventBus || new DpEventBus();
}

window.VueRequest = {
  locations: {
    getCountryList,
  },
  helpCentre: {
    getDapContext,
  },
  people: {
    employeeGet: employeesGet,
  },
  leave: isOnce
    ? {}
    : {
        isLeaveManagementEnabled: checkIsLeaveManagementEnabled,
      },
  schedule: {
    saveTemplate,
  },
};

window.VueEvents = VueEvents;
window.VueDefinitions = VueDefinitions;
window.VueNextRequest = VueNextRequest;
window.VueFacades = {
  userHasPermission,
  hasMultipleLocationSelected,
};

window.globalLibs = window.globalLibs || {};

window.globalLibs.i18NextPromise =
  getRootDeputyFrame().globalLibs?.i18NextPromise || createI18n();

window.globalLibs.PreferencesV2Service =
  getRootDeputyFrame().globalLibs?.PreferencesV2Service || PreferencesV2;

window.globalLibs.trackForInstall = trackForInstall;
window.globalLibs.trackForInstallLegacyModel = trackForInstallLegacyModel;
window.globalLibs.identifyAnalyticsUser = identifyAnalyticsUser;
window.globalLibs.SupportService = SupportService;

window.deputySdk = deputySdk;

// // needs to be here to load it first
if (checkFF('core-0-vue-router')) {
  classicRouterRetrofeed();
}

// initialize content considering FF
async function initializeGlobalLibs() {
  // necessary "hacks" from new People vue tab to temporarily prevent classic to break
  peopleGlobalRetroFeed();

  if (isWindowDeputyRootFrame()) {
    try {
      await window.globalLibs.PreferencesV2Service.getPreferences();
    } catch (e) {
      console.error('globalLibs.PreferencesV2Service.getPreferences', e);
    }
  }
}

documentReady(initializeGlobalLibs);
